const FAQ2 = () => {
    return (
        <div>
            <h3>Réservation</h3>
            <details>
                <summary>Comment puis-je réserver un tour?</summary>
                <p>Vous pouvez simplement envoyer un message en indiquant quel tour vous souhaitez réserver à quelle date. Je vous répondrai avec mes disponibilités et nous pourrons ensuite y aller de l'avant!</p>
            </details>
            <details>
                <summary>Est-ce que je dois payer à l'avance?</summary>
                <p>Non, vous payez sur place avec un virement Interac, Paypal ou en argent comptant.</p>
            </details>
            <details>
                <summary>Est-ce que je peux connaitre vos disponibilités?</summary>
                <p>Malheureusement, je n'ai pas de calendrier de disponibilités sur mon site web car celui-ci changerait tous les deux jours. L'idéal serait de me dire quels jours vous serez à Montréal, et je vous dirais ensuite quels jours fonctionneraient pour moi.</p>
            </details>
            <details>
                <summary>J'ai réservé une visite du Plateau, mais du coup, ils annoncent beaucoup de pluie. Est-ce que je peux faire la visite de la ville souterraine à la place?</summary>
                <p>Bonne idée! Et certainement!</p>
            </details>
        </div>
    )
}

export default FAQ2;